export default __webpack_public_path__ + "static/media/new-icon.e4e3a6da.svg";